import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RewrdsRoutingModule } from './rewards-routing.module';
import { AdminSharedModule } from '../../../shared/admin-shared.module';
import { RewardsComponent } from './components/rewards/rewards.component';
import { RewardsTabletComponent } from './components/rewards-tablet/rewards-tablet.component';
import { RewardsDesktopComponent } from './components/rewards-desktop/rewards-desktop.component';
import { FormsModule } from '@angular/forms';

@NgModule({
  imports: [CommonModule, RewrdsRoutingModule, AdminSharedModule, FormsModule],
  declarations: [
    RewardsComponent,
    RewardsTabletComponent,
    RewardsDesktopComponent,
  ],
})
export class RewardsModule {}
